<div class="container sms004">
  <!-- ヘッダーエリア -->
  <app-header></app-header>

  <!-- メインエリア -->
  <div class="main-area">

    <!-- コンテンツエリア -->
    <div class="content-area" [style.width]="windowsWidth">

      <!-- フォームエリア -->
      <form class="sms-form">
        <div [formGroup]="smsForm">

          <br>
          <!-- 文言 -->
          <div>
            <mat-label class="message">{{lblName}}</mat-label>
          </div>
          <br>
          <div>
            <mat-label class="message">{{lblMessage01}}</mat-label>
          </div>
          <br>

          <!-- 文言 -->
          <div>
            <mat-label class="message">{{lblMessage02}}</mat-label>
          </div>
          <div>
            <mat-label class="message">{{lblMessage03}}</mat-label>
          </div>
          <div>
            <mat-label class="message">{{lblMessage04}}</mat-label>
          </div>
          <br>

          <div>
            <fieldset class="grid-frame">
              <mat-radio-group formControlName="rdoYatinYmKbn" class="radio-line" tabindex="1">
                <mat-radio-button class="grid-yatin-radio"
                                  name="rdoYatinYmKbn"
                                  *ngFor="let item of initVo; let i = index"
                                  [checked]="i === 0"
                                  [value]="item.id">
                    <div class="grid-row">
                      <mat-label class="grid-yyyymm">{{item.yatinYm}}</mat-label>
                      <mat-label class="grid-kingaku">{{item.seikyuGaku}}</mat-label>
                    </div>
                </mat-radio-button>
              </mat-radio-group>
            </fieldset>
          </div>
          <br>
          <br>

          <!-- ボタン -->
          <div class="button-area">
            <button type="submit" mat-raised-button [disabled]="!isEnableBtnBarcode" (click)="barcodeClick()" tabindex="2">{{lblBtnBarcode}}</button>
            <button type="submit" mat-raised-button [disabled]="!isEnableBtnDetail" (click)="detailClick()"  tabindex="3">{{lblBtnDetail}}</button>
          </div>
        </div>

      </form>

    </div>
  </div>

  <!-- フッターエリア -->
  <div class="footer-area">
    <div class="img-area">
      <img class="img-logo" src="assets/images/footer_ofi_copyright.png" />
    </div>
    <div class="data-operation-button-area">
      <button type="button" mat-raised-button [disabled]="!isEnableBtnMenu" (click)="backClick()" accesskey="q" tabindex="4">{{lblBtnMenu}}</button>
    </div>
  </div>

</div>
